import React from "react";
import { createRoot } from "react-dom/client";
import FormularioSolicitud from "./app/frontend/FormularioSolicitud";
import DashboardSolicitudes from "./app/frontend/DashboardSolicitudes";
import AddUserForm from "./app/frontend/features/usuarios-admin/AddUserForm";
import EditUserForm from "./app/frontend/features/usuarios-admin/EditUserForm";
import ProveedoresList from "./app/frontend/features/talleres/ProveedoresList";
import ProveedoresEdit from "./app/frontend/features/talleres/ProveedoresEdit";
import ProveedoresAlta from "./app/frontend/features/talleres/ProveedoresAlta";
import CentrosList from "./app/frontend/features/talleres/centros/CentrosList";
import CentroForm from "./app/frontend/features/talleres/centros/CentroForm";
import OtStepper from "./app/frontend/features/ordenes-trabajo/components/OtStepper";
import ExpedienteOT from "./app/frontend/features/ordenes-trabajo/components/ExpedienteOT";
import ControlAdministrativoOT from "./app/frontend/features/ordenes-trabajo/components/ControlAdministrativoOT";
import PanelAdministrativoPagos from "./app/frontend/features/ordenes-trabajo/components/PanelAdministrativoPagos";
import PanelAprobacionContraloria from "./app/frontend/features/ordenes-trabajo/components/PanelAprobacionContraloria";
import PanelAprobacionCoordinador from "./app/frontend/features/ordenes-trabajo/components/PanelAprobacionCoordinador";
import PanelAlertasPreventivo from "./app/frontend/features/ordenes-trabajo/components/PanelAlertasPreventivo";
import ApiKeysAdmin from "./app/frontend/features/api-keys/ApiKeysAdmin";

// ========================================================
// Formulario de Solicitudes
// ========================================================
const formRootElement = document.getElementById("react-form-root");
if (formRootElement) {
  const folio = formRootElement.dataset.folio;
  const isAdmin = formRootElement.dataset.admin === "true";

  const formRoot = createRoot(formRootElement);
  formRoot.render(
    <React.StrictMode>
      <FormularioSolicitud folioBienOriginal={folio} isAdmin={isAdmin} />
    </React.StrictMode>,
  );
}

// ========================================================
// Dashboard Operativo
// ========================================================
const dashboardRootElement = document.getElementById("react-dashboard-root");
if (dashboardRootElement) {
  const dashboardRoot = createRoot(dashboardRootElement);
  dashboardRoot.render(
    <React.StrictMode>
      <DashboardSolicitudes />
    </React.StrictMode>,
  );
}

// ========================================================
// Alta de Usuario Admin
// ========================================================
const addUserFormRootElement = document.getElementById("react-add-user-form");
if (addUserFormRootElement) {
  const addUserFormRoot = createRoot(addUserFormRootElement);
  addUserFormRoot.render(
    <React.StrictMode>
      <AddUserForm />
    </React.StrictMode>,
  );
}

// ========================================================
// Editar Usuario Admin
// ========================================================
const editUserRoot = document.getElementById('react-edit-user-root');
if (editUserRoot) {
  const root = createRoot(editUserRoot);
  root.render(
    <React.StrictMode>
      <EditUserForm />
    </React.StrictMode>
  );
}

// ========================================================
// Listado de Proveedores (Talleres)
// ========================================================
const proveedoresListRootElement = document.getElementById("react-proveedores-list");
if (proveedoresListRootElement) {
  const proveedoresListRoot = createRoot(proveedoresListRootElement);
  proveedoresListRoot.render(
    <React.StrictMode>
      <ProveedoresList />
    </React.StrictMode>,
  );
}

// ========================================================
// Edición de Proveedores (Incluye Centros)
// ========================================================
const proveedoresEditRootElement = document.getElementById("react-proveedores-edit");
if (proveedoresEditRootElement) {
  const proveedoresEditRoot = createRoot(proveedoresEditRootElement);
  proveedoresEditRoot.render(
    <React.StrictMode>
      <ProveedoresEdit />
    </React.StrictMode>,
  );
}

// ========================================================
// Alta de Proveedores (Incluye Centros)
// ========================================================
const proveedoresAltaRootElement = document.getElementById("react-proveedores-alta");
if (proveedoresAltaRootElement) {
  const proveedoresAltaRoot = createRoot(proveedoresAltaRootElement);
  proveedoresAltaRoot.render(
    <React.StrictMode>
      <ProveedoresAlta />
    </React.StrictMode>,
  );
}

// ========================================================
// Listado Global de Centros (Para vistas independientes)
// ========================================================
const centrosListRootElement = document.getElementById("react-centros-list");
if (centrosListRootElement) {
  const centrosListRoot = createRoot(centrosListRootElement);
  centrosListRoot.render(
    <React.StrictMode>
      <CentrosList />
    </React.StrictMode>,
  );
}

// ========================================================
// Visualizador Orden de Trabajo (Solo Lectura)
// ========================================================
const expedienteRootElement = document.getElementById("react-expediente-root");
if (expedienteRootElement) {
  const solicitud = expedienteRootElement.dataset.solicitud!;
  const orden = expedienteRootElement.dataset.orden!;

  const expedienteRoot = createRoot(expedienteRootElement);
  expedienteRoot.render(
    <React.StrictMode>
      <ExpedienteOT solicitudId={solicitud} ordenId={orden} />
    </React.StrictMode>
  );
}

// ========================================================
// Visualizador Orden de Trabajo
// ========================================================
const otStepperRootElement = document.getElementById("react-ot-stepper");
if (otStepperRootElement) {
  const asignacion = otStepperRootElement.dataset.asignacion!;
  const solicitud = otStepperRootElement.dataset.solicitud!;
  const orden = otStepperRootElement.dataset.orden!;
  const bien = otStepperRootElement.dataset.bien!;
  const ciudad = otStepperRootElement.dataset.ciudad!;
  const categoria = otStepperRootElement.dataset.categoria!;
  const marca = otStepperRootElement.dataset.marca!;

  const tipoOrden =
    (otStepperRootElement.dataset.tipoOrden as "principal" | "adicional") ||
    "principal";
  const otPadreId = otStepperRootElement.dataset.otPadreId;

  const otStepperFormRoot = createRoot(otStepperRootElement);
  otStepperFormRoot.render(
    <React.StrictMode>
      <OtStepper
        asignacion={asignacion}
        solicitud={solicitud}
        orden={orden}
        bien={bien}
        ciudad={ciudad}
        categoria={categoria}
        marca={marca}
        tipoOrden={tipoOrden}
        otPadreId={otPadreId}
      />
    </React.StrictMode>,
  );
}

// ========================================================
// Alta y Edición de Centros (Incluye Google Maps y Slots)
// ========================================================
const centroFormRootElement = document.getElementById("react-centro-form");
if (centroFormRootElement) {
  const centroFormRoot = createRoot(centroFormRootElement);
  centroFormRoot.render(
    <React.StrictMode>
      <CentroForm />
    </React.StrictMode>,
  );
}

// ========================================================
// Módulo de Control Administrativo (Auxiliares)
// ========================================================
const adminRootElement = document.getElementById("react-control-admin-root");
if (adminRootElement) {
  const orden = adminRootElement.dataset.orden!;
  const adminRoot = createRoot(adminRootElement);
  adminRoot.render(
    <React.StrictMode>
      <ControlAdministrativoOT ordenId={orden} />
    </React.StrictMode>
  );
}

// ========================================================
// Panel Maestro de Facturación y Pagos Consolidada (Global)
// ========================================================
const panelAdminPagosRoot = document.getElementById("react-panel-admin-pagos-root");
if (panelAdminPagosRoot) {
  const root = createRoot(panelAdminPagosRoot);
  root.render(
    <React.StrictMode>
      <PanelAdministrativoPagos />
    </React.StrictMode>,
  );
}

// ========================================================
// Panel de aprobación de Contraloría
// ========================================================
const panelAdminContraloriaRoot = document.getElementById("react-panel-admin-contraloria-root");
if (panelAdminContraloriaRoot) {
  const root = createRoot(panelAdminContraloriaRoot);
  root.render(
    <React.StrictMode>
      <PanelAprobacionContraloria />
    </React.StrictMode>,
  );
}

// ========================================================
// Panel de aprobación de Coordinación
// ========================================================
const panelAdminCoordinacionRoot = document.getElementById("react-panel-admin-coordinacion-root");
if (panelAdminCoordinacionRoot) {
  const root = createRoot(panelAdminCoordinacionRoot);
  root.render(
    <React.StrictMode>
      <PanelAprobacionCoordinador />
    </React.StrictMode>,
  );
}

// ========================================================
// Panel alertas preventivo (Admin Talleres)
// ========================================================
const panelAlertasPreventivoRoot = document.getElementById("react-panel-alertas-preventivo-root");
if (panelAlertasPreventivoRoot) {
  const root = createRoot(panelAlertasPreventivoRoot);
  root.render(
    <React.StrictMode>
      <PanelAlertasPreventivo />
    </React.StrictMode>,
  );
}

// ========================================================
// Administración de API Keys
// ========================================================
const apiKeysRootElement = document.getElementById("react-api-keys");
if (apiKeysRootElement) {
  const canAdd = apiKeysRootElement.dataset.canAdd === "true";
  const canRevoke = apiKeysRootElement.dataset.canRevoke === "true";
  const apiKeysRoot = createRoot(apiKeysRootElement);

  apiKeysRoot.render(
    <React.StrictMode>
      <ApiKeysAdmin canAdd={canAdd} canRevoke={canRevoke} />
    </React.StrictMode>,
  );
}